<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="common_title">
        现货资金流水
        <TopPartner @refreshTopPartner="handleSearch"></TopPartner>
      </div>
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <!-- <div class="txt">用户UID</div> -->
            <div class="ipt">
              <el-input placeholder="用户UID" clearable v-model="userId" class="userUid_ipt" size="mini">
                <!-- <img :src="userUid" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>

          <div class="item">
            <!-- <div class="txt">合伙人UID</div> -->
            <div class="ipt">
              <el-input placeholder="合伙人UID" clearable v-model="channelUserId" class="userUid_ipt" size="mini">
                <!-- <img :src="channel" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">合约名称</div> -->
            <div class="ipt">
              <el-select size="mini" :rules="[
                { required: true, message: '请选择', trigger: 'change' },
              ]" v-model="coin" placeholder="请选择" @change="changeName">
                <el-option value="" label="全部币种"></el-option>

                <el-option v-for="item in coinList" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">合约名称</div> -->
            <div class="ipt">
              <el-select size="mini" @change="changeCoin" :rules="[
                { required: true, message: '请选择', trigger: 'change' },
              ]" v-model="billType" placeholder="请选择">
                <el-option label="全部类型" value=""> </el-option>
                <el-option v-for="item in businessTypeOptions" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">注册日期</div> -->
            <div class="ipt">
              <el-date-picker v-model="value1" size="mini" type="daterange" align="right" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" unlink-panels range-separator="-" start-placeholder="开始日期"
                end-placeholder="结束日期" @change="changeTime($event)" :picker-options="pickerOptions">
              </el-date-picker>
            </div>
          </div>
          <!-- <div class="item">
            <el-button size="mini" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="searchToday">今日</el-button>
          </div> -->
          <div class="item">
            <div class="item-sle">
              <div class="tit">用户范围</div>
              <el-select size="mini" v-model="type" placeholder="用户范围">
                <el-option v-for="item in [
                  { id: 1, value: '隐藏（仅普通用户）' },
                  { id: 2, value: '显示（普通+模拟+特殊）' },
                ]" :key="item.id" :label="item.value" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
          </div>
          <div class="item">
            <el-button size="mini" :loading="exportLoading" @click="getExcel">导出</el-button>
          </div>
        </div>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import userUid from "@/assets/input/userUid.png";
import invite from "@/assets/input/invite.png";
import channel from "@/assets/input/channel.png";
import TopPartner from "../topPartner";
import moment from "moment";
export default {
  name: "spotBill",
  components: {
    UserList,
    TopPartner,
  },
  data() {
    return {
      invite,
      channel,
      userUid,
      value2: "",
      type: 1,
      exportLoading: false,
      dialogVisible: false,
      userId: "",
      channelId: "",
      channelUserId: "",
      positionId: "",
      billType: "",
      coin: "",
      // value1: [
      // moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     "YYYY-MM-DD"
      //   ),
      //   new Date().getFullYear() +
      //     '-' +
      //     (new Date().getMonth() + 1) +
      //     '-' +
      //     new Date().getDate(),
      // ],
      value1: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      businessTypeOptions: [
        { value: "exchange", label: "划转" },
        { value: "trade_deal", label: "交易" },
        { value: "OPEN_ORDER_FREEZE", label: "下单冻结" },
        { value: "CANCEL_TRADE", label: "取消订单" },
        { value: "TRADE_FEE", label: "手续费" },
        { value: "DEPOSIT", label: "充值" },
        { value: "WITHDRAW", label: "提现" },
        { value: "WITHDRAW_FEE", label: "提现手续费" },
        { value: "WITHDRAW_CONFIRM", label: "提现成功" },
        { value: "CANCEL_WITHDRAW", label: "取消提现" },
        // { value: "DEPOSITE_INTERNAL_TRANSFER", label: "内部转账" },
        { value: "internal_transfer_freeze", label: "内部转出" },
        { value: "internal_transfer_confirm", label: "内部转出成功" },
        { value: "internal_transfer_fee", label: "内部转出手续费" },
        { value: "INVITATION_REWARD", label: "返佣，邀请奖励" },
        { value: "LEVER_BORROW", label: "杠杆借款" },
        { value: "LEVER_REPAYMENT", label: "杠杆还款" },
        { value: "LEVER_LIQUIDATION", label: "杠杆爆仓" },
        { value: "USER_SEND_COIN", label: "赠币" },
        { value: "CANCELD_ORDER_UNFREEZE", label: "撤单解冻" },
        { value: "CHANNEL_SEND_REBADE", label: "合伙人返佣" },
        { value: "USER_AIRDROP_AWARD", label: "空投" },
        { value: "PROFIT_BONUS_REWARD", label: "盈加码奖励" },
        { value: "WELFARE_FEE_DEDUCT_REFUND", label: "手续费抵扣返还" },
        { value: "WELFARE_PNL_DEDUCT_REFUND", label: "盈亏抵扣返还" },
        { value: "WELFARE_TOKEN_GRANT", label: "代币券兑换" },
        { value: "ABNORMAL_ASSET_DEDUCT", label: "异常资产扣除" },
      ],
    };
  },
  computed: {
    ...mapState("currentDelegation", ["symbolList"]),
    ...mapState("spotBill", [
      "queryType",
      "queryTypeList",
      "pagination",
      "coinList",
    ]),
    ...mapState(["userInfo"]),
    ...mapState("topPartner", ["topPartner"]),
  },
  methods: {
    ...mapActions("spotBill", ["list", "getCoinList", "exportExcel"]),
    ...mapActions("currentDelegation", ["getSymbolList"]),
    ...mapMutations("spotBill", ["setQueryType"]),
    refreshList(data = {}) {
      this.list({
        channelId: this.topPartner,
        coin: this.coin,
        channelUserId: this.channelUserId,
        userId: this.userId,
        billType: this.billType,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...this.pagination,
        ...data,
      });
    },
    changeName(e) {
      this.handleSearch();
    },
    changeCoin(e) {
      this.billType = e;
      this.list({
        channelId: this.topPartner,
        coin: this.coin,
        channelUserId: this.channelUserId,
        userId: this.userId,
        billType: e,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...PAGINATION,
      });
    },
    changeTime(e) {
      this.list({
        coin: this.coin,
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        billType: this.billType,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...PAGINATION,
      });
    },
    searchYesterday() {
      this.value1 = [
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() - 1),
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() - 1),
      ];
      this.handleSearch();
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate(),
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate(),
      ];
      this.handleSearch();
    },
    handleSearch() {
      this.list({
        coin: this.coin,
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        billType: this.billType,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...PAGINATION,
      });
    },
    async getExcel() {
      if (this.exportLoading) return;
      this.exportLoading = true;
      let url;
      try {
        const res = await this.exportExcel({
          coin: this.coin,
          channelId: this.topPartner,
          channelUserId: this.channelUserId,
          userId: this.userId,
          billType: this.billType,
          type: this.type,
          startTime: this.value1 ? this.value1[0] : "",
          endTime: this.value1 ? this.value1[1] : "",
        });
        const blob = res instanceof Blob ? res : new Blob([res], { type: "application/vnd.ms-excel" });
        url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "现货资金流水.xls";
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        this.$message.error("导出失败，请重试");
      } finally {
        if (url) URL.revokeObjectURL(url);
        this.exportLoading = false;
      }
    },
    handleSave() { },
    closeDialog() {
      this.dialogVisible = false;
    },
    onOpen() { },
    onClose() {
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
  },
  created() {
    this.getCoinList({ type: "SPOT" });
    this.list({
      coin: this.coin,
      channelId: this.topPartner,
      channelUserId: this.channelUserId,
      userId: this.userId,
      billType: this.billType,
      type: this.type,
      startTime: this.value1 ? this.value1[0] : "",
      endTime: this.value1 ? this.value1[1] : "",
      ...PAGINATION,
    });
  },
};
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
